import type {
  Subscriber,
  SubscriberFilters,
  SubscriberLevelCounts,
  SubscriberPage
} from '../../domain/models/subscriber'

export class SubscriberEntity implements Subscriber {
  name!: string | null
  username!: string | null
  email!: string
  image_url!: string | null
  region!: string | null
  country!: string | null
  subscription_source!: string
  subscription_plan!: string | null
  subscription_level!: string
  previous_subscription_level!: string | null
  subscription_status!: string | null
  joined_at!: string | null
}

export class SubscriberPageEntity implements SubscriberPage {
  total!: number
  items!: SubscriberEntity[]
}

export class SubscriberFiltersEntity implements SubscriberFilters {
  subscription_sources!: string[]
  subscription_plans!: string[]
  subscription_levels!: string[]
  previous_subscription_levels!: string[]
  subscription_statuses!: string[]
  regions!: Record<string, string[]>
}

export class SubscriberLevelCountsEntity implements SubscriberLevelCounts {
  [level: string]: number
}
